module.exports = new __parcel__URL__("monite_dark.13bcd553.png").toString();